// App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import '@cds/core/global.min.css'; 
import '@cds/core/icon/shapes/angle.js'; 
import "./App.css";
import Footer from "./components/Footer";
import Career from "./pages/careers";
import Lattice from "./pages/ Lattice";
import Underwater from "./pages/Underwater";
import Air from "./pages/air";
import Rocket from "./pages/rocket";
import Force from "./pages/force";
import Contact from "./pages/contact";
import Mission from "./pages/mission";
import Communications from "./pages/Communication";
import AIVision from "./pages/AIVision";
import CyberSecurity from "./pages/CyberSecurity";


const App: React.FC = () => {
  return (
    <Router>
      <Navbar />
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/lattice" element={<Lattice />} />
          <Route path="/underwater" element={<Underwater />} />
          <Route path="/air" element={<Air />} />
          <Route path="/rocket" element={<Rocket />} />
          <Route path="/force" element={<Force />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/ai-vision" element={<AIVision />} />
          <Route path="/Communication" element={<Communications />} />
          <Route path="/cybersecurity" element={<CyberSecurity />} />
         

        </Routes>
      </div>
    <Footer/>
    </Router>
  );
};

export default App;
